export const filter = {
    id: "",
    created_at: "",
    updated_at: "",
};